// src/components/Pimgy/ReceivePayments.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { getTodayYYYYMMDD } from '../../utils/dateUtils';
import '../GL/LoanPayment.css';

const ReceivePayments = () => {
  const [applications, setApplications] = useState([]);
  const [payments, setPayments] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState({});

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/api/pimgy/active-applications`);
      setApplications(response.data);
      
      // Initialize payment amounts
      const paymentState = {};
      response.data.forEach(app => {
        paymentState[app.registration_no] = '';
      });
      setPayments(paymentState);
    } catch (error) {
      console.error('Error fetching applications:', error);
      alert('Failed to load applications');
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentChange = (registrationNo, value) => {
    setPayments(prev => ({
      ...prev,
      [registrationNo]: value
    }));
  };

  const handlePay = async (registrationNo) => {
    const paymentAmount = parseFloat(payments[registrationNo]);
    
    if (!paymentAmount || paymentAmount <= 0) {
      alert('Please enter a valid payment amount');
      return;
    }

    if (!window.confirm(`Confirm payment of ₹${paymentAmount.toFixed(2)} for ${registrationNo}?`)) {
      return;
    }

    try {
      setSubmitting(prev => ({ ...prev, [registrationNo]: true }));
      
      await axios.post(`${API_BASE_URL}/api/pimgy/receive-payment`, {
        registration_no: registrationNo,
        payment_amount: paymentAmount,
        payment_date: getTodayYYYYMMDD(),
        payment_mode: 'Cash',
        transaction_id: null
      });

      alert('Payment received successfully!');
      
      // Clear payment amount for this registration
      setPayments(prev => ({
        ...prev,
        [registrationNo]: ''
      }));
      
      // Refresh applications list
      fetchApplications();
    } catch (error) {
      console.error('Error receiving payment:', error);
      alert(error.response?.data?.error || 'Failed to receive payment');
    } finally {
      setSubmitting(prev => ({ ...prev, [registrationNo]: false }));
    }
  };

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading applications...</div>;
  }

  return (
    <div className="loan-payment-container">
      <div className="loan-payment-form">
        <h1>Receive Payments</h1>
        
        {applications.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <p>No active applications found.</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Registration No</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Name</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'right' }}>Daily Amount</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'right' }}>Total Paid</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'right' }}>Pay Amount</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((app) => (
                  <tr key={app.registration_no}>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>{app.registration_no}</td>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>{app.name}</td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'right' }}>
                      ₹{Number(app.daily_amount).toFixed(2)}
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'right' }}>
                      ₹{Number(app.total_paid || 0).toFixed(2)}
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>
                      <input
                        type="number"
                        value={payments[app.registration_no] || ''}
                        onChange={(e) => handlePaymentChange(app.registration_no, e.target.value)}
                        placeholder="Enter amount"
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: '1px solid #ccc',
                          borderRadius: '4px'
                        }}
                        min="0"
                        step="0.01"
                      />
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>
                      <button
                        onClick={() => handlePay(app.registration_no)}
                        disabled={submitting[app.registration_no]}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: submitting[app.registration_no] ? 'not-allowed' : 'pointer',
                          opacity: submitting[app.registration_no] ? 0.6 : 1
                        }}
                      >
                        {submitting[app.registration_no] ? 'Processing...' : 'Pay'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReceivePayments;

